import React, {useEffect} from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import Aboutone from '../menabout/Aboutone'
import Client from '../../menhome/Client'
import Testimonial from '../menabout/Testimonial'
import Team from '../../menhometwo/Team'
import Last from '../menabout/Last'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="About Us || State of GTS";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom
           subtitle="Home"
           title="About"
           subtitledown="About"
           />
          <Aboutone/>
          <Client/>
          <Testimonial/>
          {/* <Team/> */}
          <Last/>
        </div>
        
    </>
  )
}

export default Main